export enum Experiment {
  ViewerCustomProfile = 'specs.membersArea.viewerCustomProfile',
  CustomProfile = 'specs.membersArea.customProfile',
}
